module.exports = __webpack_public_path__ + "static/lightning-table-truncate-content-93cbea28afc9d4e06b240172d192719b.png";